export var IBusinessIdentifier;
(function (IBusinessIdentifier) {
    let IdentifierType;
    (function (IdentifierType) {
        IdentifierType["VAT"] = "VAT";
        IdentifierType["EORI"] = "EORI";
        IdentifierType["CANADA_SALES_TAX"] = "CANADA_SALES_TAX";
        /**
         * SIREN numbers are trade registry numbers required by the French government on a brand's order invoices
         */
        IdentifierType["SIREN"] = "SIREN";
        /**
         * KVK numbers are dutch business registration numbers, we show Faire's KVK number on commission invoices
         */
        IdentifierType["KVK"] = "KVK";
        /**
         * Australian Business Register number, mandatory for all businesses in AUS
         */
        IdentifierType["ABN"] = "ABN";
        /**
         * Optional Australian goods and services tax number. This will have the same numerical value as the ABN.
         */
        IdentifierType["AUSTRALIA_GST"] = "AUSTRALIA_GST";
        /**
         * Brands that ship to Germany need to register for a LUCID number to verify they are compliant with German packaging laws
         */
        IdentifierType["LUCID"] = "LUCID";
        /**
         * Optional Canadian goods and services tax/harmonized sales tax registration number
         */
        IdentifierType["CANADA_GST"] = "CANADA_GST";
        /**
         * Optional Canadian Quebec sales tax registration number
         */
        IdentifierType["CANADA_QST"] = "CANADA_QST";
        /**
         * Alcohol Wholesaler Registration Scheme, required for UK based brands to sell alcohol
         */
        IdentifierType["AWRS_URN"] = "AWRS_URN";
        /**
         * Australian Registration Number
         */
        IdentifierType["ARN"] = "ARN";
        /**
         * Canadian business number collected during sign up
         */
        IdentifierType["CANADA_BUSINESS_NUMBER"] = "CANADA_BUSINESS_NUMBER";
        /**
         * business number for countries outside of NAM collected during sign up
         */
        IdentifierType["GLOBAL_BUSINESS_NUMBER"] = "GLOBAL_BUSINESS_NUMBER";
    })(IdentifierType = IBusinessIdentifier.IdentifierType || (IBusinessIdentifier.IdentifierType = {}));
    let IdentifierState;
    (function (IdentifierState) {
        /**
         * This is a valid identifier and can be used
         */
        IdentifierState["VALID"] = "VALID";
        /**
         * This identifier has been marked as deleted, and should not be used.
         */
        IdentifierState["DELETED"] = "DELETED";
        /**
         * This identifier has been requested but the retailer/brand did not have the identifier
         */
        IdentifierState["REQUESTED"] = "REQUESTED";
    })(IdentifierState = IBusinessIdentifier.IdentifierState || (IBusinessIdentifier.IdentifierState = {}));
    /**
     * Return an instance of IBusinessIdentifier with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBusinessIdentifier.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IBusinessIdentifier || (IBusinessIdentifier = {}));
